export default "__VITE_ASSET__wPM40xJP__"